module.exports = __webpack_public_path__ + "img/news_02.a6dfb9a3.png";